import { FilterList } from "@mui/icons-material";
import { Box } from "@mui/material";
import { ReactNode } from "react";

export type FilterFormProps = {
  filterBar: ReactNode;
  quickFilterBar: ReactNode;
  activeFilterBar: ReactNode;
};

export function FilterForm({
  filterBar,
  quickFilterBar,
  activeFilterBar,
}: FilterFormProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {filterBar}

      <Box
        sx={{
          width: "100%",
          display: "flex",
          columnGap: 2,
          rowGap: 1,
        }}
      >
        {(quickFilterBar || activeFilterBar) && (
          <Box
            sx={{
              display: "flex",
              fontWeight: 700,
              gap: 1,
              py: 0.75,
            }}
          >
            <FilterList />
            Filters
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            width: "100%",
          }}
        >
          {quickFilterBar}

          {activeFilterBar}
        </Box>
      </Box>
    </Box>
  );
}
